export default {
  category: 'book',
  name: 'Plant Based High Protein Cookbook',
  author: 'Sarah Cook',
  date: '11/10/20',
  path: '/notes/plant-based-high-protein-cookbook',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-plant-based-high-protein-cookbook-sarah-cook.jpg',
  tags: ['Food', 'Diet'],
  time: 1,
  rating: 3.4,
  review: '',
  link: 'https://www.amazon.com/PLANT-BASED-HIGH-PROTEIN-COOKBOOK/dp/B084DG2YRK',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
twosLink: '',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: ''
};
